import { Navigate, Route, Routes } from "react-router-dom";
import AboutUsPage from "../app/components/company/about-us";
import MissionVisionPage from "../app/components/security-services/mission-vision";
import ServicesPage from "../app/components/security-services/services/services";
import ServicesDetailPage from "../app/components/security-services/services/detail";
import OperationsListPage from "../app/components/security-services/operations/operations-list";
import OperationDetailPage from "../app/components/security-services/operations/operation-detail";
import InsightsGridPage from "../app/components/insights/insights-grid";
import InsightDetailPage from "../app/components/insights/insight-detail";
import ContactUsPage from "../app/components/contact/contact-page";
import Home2Page from "../app/components/home/index2";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home2Page />} />
      <Route path="/about-us" element={<AboutUsPage />} />
      <Route path="/mission" element={<MissionVisionPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/services/:slug" element={<ServicesDetailPage />} />
      <Route path="/operations" element={<OperationsListPage />} />
      <Route path="/operations/:slug" element={<OperationDetailPage />} />
      <Route path="/insights" element={<InsightsGridPage />} />
      <Route path="/insights/:slug" element={<InsightDetailPage />} />
      <Route path="/contact-us" element={<ContactUsPage />} />

      <Route path="/index2" element={<Navigate to="/" replace />} />
      <Route path="/services/detail/:slug" element={<ServicesDetailPage />} />
      <Route path="/services/detail" element={<Navigate to="/services" replace />} />
      <Route path="/portfolio" element={<Navigate to="/operations" replace />} />
      <Route path="/portfolio2" element={<Navigate to="/operations" replace />} />
      <Route path="/portfolio/detail/:slug" element={<OperationDetailPage />} />
      <Route path="/portfolio/detail" element={<Navigate to="/operations" replace />} />
      <Route path="/blogs" element={<Navigate to="/insights" replace />} />
      <Route path="/blogs/detail/:slug" element={<InsightDetailPage />} />
      <Route path="/blogs/detail" element={<Navigate to="/insights" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;
